import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../config';

import AdFoxFactory from '../../../ui/AdFox/AdFoxFactory';
import TableView from './TableView';

class GridView extends TableView {
  constructor (props) {
    super(props);

    this.ADFOX_LIMIT = 10;
    this.regionName = props.domain.get('domain', '') || '';
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (process.env.BROWSER && (!this.props.data.equals(prevProps.data) || this.props.isLoading)) {
      window.scrollTo(0, 0);
    }
  }

  getRealtyList () {
    const realtyList = [];
    const { dealType, realtyType } = this.props;
    const drawAdFox = ((this.props.data.size / this.ADFOX_LIMIT > 1) && config.enableAdFox);
    const columnList = this.getColumnList();
    const colSpan = columnList.length;
    const hashCode = this.props.data.hashCode();

    this.props.data.map((item, index) => {
      realtyList.push(this.getRealtyRow(item));

      // рекламная строчка после каждого 10 объявления
      if (drawAdFox && ((index + 1) % this.ADFOX_LIMIT === 0)) {
        const position = AdFoxFactory.getListingGridPosition((index + 1) / this.ADFOX_LIMIT);
        const adFoxEl = AdFoxFactory(this.regionName).getBySection(position, dealType, realtyType);

        if (position && adFoxEl) {
          realtyList.push(
            <tr className='no-padding no-print' key={position + hashCode}>
              <td colSpan={colSpan}>
                { adFoxEl }
              </td>
            </tr>
          );
        }
      }
    });

    return realtyList;
  }
}

GridView.propTypes = {
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventMapModal: PropTypes.func,
  eventShowContacts: PropTypes.func
};

GridView.defaultProps = {
  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventMapModal: id => {},
  eventShowContacts: id => {}
};

export default GridView;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/GridView.jsx